import React from 'react';
import { Link } from 'react-router-dom';
import service from "../../assets/images/resource/vr.png";

const ProductTwo = () => {
    return (
        <section>
            <figure>
                <img src={service} alt="" />
            </figure>
            <h2>Virtual <span>Maintenance Training</span> Simulator</h2>
            <p>
                The mechanic maintenance simulator uses a PC/laptop and VR device, as well as evaluation software to learn the science of unit functions and how to maintain the unit procedurally.
            </p>
            <p>&nbsp;</p>
            <p>
                Using Virtual Reality (VR) technology has important advantages with an objective calculation system, users are trained for unit familiarization, introduction to the main functions and features of the unit, according to accountable procedures.
            </p>

            <div className="row">
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Part Introduction</Link></li>
                </div>
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Procedure Tutorial</Link></li>
                </div>
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Training</Link></li>
                </div>
                <div className="col-lg-6 col-md-12">
                    <li> <Link to="#">Scoring System</Link></li>
                </div>
            </div>
        </section>
    )
}

export default ProductTwo